/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type RecordTerminationDtoReason = typeof RecordTerminationDtoReason[keyof typeof RecordTerminationDtoReason];


export const RecordTerminationDtoReason = {
  contract_expiry: 'contract_expiry',
  mutual_termination: 'mutual_termination',
  transfer_to_other_agency: 'transfer_to_other_agency',
  player_retirement: 'player_retirement',
  termination_for_cause: 'termination_for_cause',
  other: 'other',
} as const;
